export default {
  memberReferral: '好友推薦',
  'memberReferral.title': '與好友一起拿獎勵',
  'memberReferral.description': '請好友於註冊時輸入推薦碼<br />或直接點擊推薦連結進行註冊',
  'memberReferral.code': '推薦碼',
  'memberReferral.url': '推薦連結',
  'memberReferral.copy.success': '複製成功！',
  'memberReferral.message.disabled': '目前非活動期間！',
  'memberReferral.message.title': '邀請你一起加入{name}',
  'memberReferral.message.description':
    '好友推薦碼：{code}，註冊時輸入推薦碼，或直接點擊推薦連結進行註冊',
  'memberReferral.message.join': '加入會員',
  'memberReferral.message.share': '分享',
  'memberReferral.message.success': '邀請連結分享成功！',
  'memberReferral.message.version': 'LINE 版本過舊，請更新後再試一次',
  'memberReferral.message.fail': '分享失敗，請稍後再試一次',
} as Record<string, string>;
